import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { AiAgentSelectPopover } from '@/modules/analytics/components/aiAgents/AiAgentSelectPopover';

import { AnalyticsEmptyState } from './AnalyticsEmptyState';

/**
 * Empty state shown at the bottom of the AI Agents analytics page when no
 * AI Agent is selected in the filters. Prompts the user to pick an agent via
 * the `AiAgentSelectPopover`, which updates the `brainIds` filter in Redux.
 */
export const AiAgentsInsightsEmptyState = () => {
  const { t } = useTranslation();

  return (
    <section className="flex items-center justify-center rounded-lg border border-border bg-background p-6">
      <AnalyticsEmptyState
        icon="lightbulb"
        title={t('analytics.insights_unavailable_title')}
        description={t('analytics.insights_unavailable_description')}
        action={
          <AiAgentSelectPopover align="center" side="top">
            <Button variant="outline-neutral" size="sm">
              {t('analytics.insights_unavailable_action')}
            </Button>
          </AiAgentSelectPopover>
        }
      />
    </section>
  );
};
